var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sistemaLoading)?_c('div',[_vm._v(" Cargando... ")]):_c('div',_vm._l((_vm.sistemaList),function(sistema,index){return _c('SistemaCard',{key:`sistema-list-${index}-${sistema.id}`,attrs:{"sistema":sistema}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }